import { render, staticRenderFns } from "./optinoptout.vue?vue&type=template&id=25c65aca&scoped=true"
import script from "./optinoptout.vue?vue&type=script&lang=js"
export * from "./optinoptout.vue?vue&type=script&lang=js"
import style0 from "./optinoptout.vue?vue&type=style&index=0&id=25c65aca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c65aca",
  null
  
)

export default component.exports